/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const postApiClients200Schema = z.any();

export const postApiClientsMutationRequestSchema = z.object({
  id: z.coerce.number().int().nullable().nullish(),
  name: z.coerce.string().min(1).max(500),
  enabled: z.boolean(),
  canHaveUnconfirmedProjects: z.boolean().nullable().nullish(),
  societa: z.array(
    z.object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    }),
  ),
});

export const postApiClientsMutationResponseSchema = z.lazy(
  () => postApiClients200Schema,
);
